module.exports = __webpack_public_path__ + "static/media/03-mobile-1.794b3fab.png";